export default __webpack_public_path__ + "static/media/star-outline-rounded.c2c45aad.svg";